import React from 'react'

function Centered({ as: Comp = 'div', children, maxWidth = '1050px', ...rest }) {
  return (
    <Comp {...rest} style={{ maxWidth }} data-layout-centered="">
      {children}
    </Comp>
  )
}

export default Centered
